class Documentation {
	constructor() {
		this.filterInput = document.querySelector("#documentationFilter");
		if (!this.filterInput) {
			return;
		}

		this.noResultMessage = document.querySelector(".no-result-message");
		this.products = document.querySelectorAll(".product-container");

		this.initFilterByName();
		this.filterByType();
	}

	initFilterByName() {
		this.filterInput.addEventListener("keyup", e => {
			this.nameFilter = e.target.value;
			this.filterProducts();
		});
		this.filterInput.addEventListener("search", e => {
			this.nameFilter = e.target.value;
			this.filterProducts();
		});
		this.filterInput.addEventListener("change", e => {
			this.nameFilter = e.target.value;
			this.filterProducts();
		});
	}

	filterByType() {
		document.querySelector(".filters .custom-select").addEventListener("customselect", (e) => {
			if (e.detail === "all") {
				this.typeFilter = null;
			} else {
				this.typeFilter = e.detail;
			}
			this.filterProducts(e.detail);
		});
	}

	filterProducts() {
		let productToDisplay = 0;
		this.products.forEach(product => {
			product.classList.add("d-none");
			if (this.typeFilter) {
				if (!product.dataset.type.toLowerCase().includes(this.typeFilter.toLowerCase())) {
					return;
				}
			}
			if (this.nameFilter) {
				if (!product.dataset.name.toLowerCase().includes(this.nameFilter.toLowerCase())) {
					return;
				}
			}
			productToDisplay++;
			product.classList.remove("d-none");
		});
		if (productToDisplay === 0) {
			this.noResultMessage.classList.remove("d-none");
		} else {
			this.noResultMessage.classList.add("d-none");
		}
		ScrollTrigger.refresh();
	}
}
